export default __webpack_public_path__ + "static/media/discord-icon-input.38539fad.svg";